import { MockRecordController } from './MockRecordController'
import { MockReplayController } from './MockReplayController'
import * as S from './styles'

export const MockControls = () => {
    return (
        <S.AbsoluteContainer>
            {document.mocks.getMode() === 'replay' ? <MockReplayController /> : <MockRecordController />}
        </S.AbsoluteContainer>
    )
}
